// What a shared m-Card shows, in this order. The scope (which of these a patient shared) is decided by Core,
// so a field that is missing from the response is simply not shown.
export const MCARD_SHARE_SECTIONS = [
    { key: 'allergies', label: 'allergies' },
    { key: 'personalMedicalConditions', label: 'medical_conditions' },
    { key: 'chronicConditions', label: 'chronic_conditions' },
    { key: 'proceduresOrSurgeries', label: 'procedures' },
    { key: 'medications', label: 'medications' },
    { key: 'vaccines', label: 'vaccines' },
    { key: 'primaryCareProvider', label: 'primary_care_provider' },
    { key: 'emergencyContact', label: 'emergency_contact' },
    { key: 'familyMedicalConditions', label: 'family_history' },
    { key: 'preferredFarmacy', label: 'pharmacy' },
]

function isEmpty(value) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)
}

function toWords(key) {
    return String(key)
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .trim()
        .toLowerCase()
}

// One line of text for a value of any shape: text and numbers as they are, an object as "label: value, ...",
// leaving out empty fields and internal ids.
export function formatMcardValue(value) {
    if (isEmpty(value)) return ''
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return String(value)
    if (Array.isArray(value)) {
        return value.map(formatMcardValue).filter(Boolean).join(', ')
    }
    if (typeof value === 'object') {
        if (typeof value.name === 'string' && value.name) {
            const rest = Object.keys(value)
                .filter((key) => key !== 'name' && !/(^id$|Id$)/.test(key))
                .map((key) => [key, formatMcardValue(value[key])])
                .filter(([, text]) => text)
            return rest.length ? `${value.name} (${rest.map(([key, text]) => `${toWords(key)}: ${text}`).join(', ')})` : value.name
        }
        return Object.keys(value)
            .filter((key) => !/(^id$|Id$)/.test(key))
            .map((key) => [key, formatMcardValue(value[key])])
            .filter(([, text]) => text)
            .map(([key, text]) => `${toWords(key)}: ${text}`)
            .join(', ')
    }
    return ''
}

// The lines to show for one section: one per list item, or a single line for a single value.
export function mcardSectionLines(value) {
    if (isEmpty(value)) return []
    const items = Array.isArray(value) ? value : [value]
    return items.map(formatMcardValue).filter(Boolean)
}
